/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ControlEntityAssetsDomainsResult } from './ControlEntityAssetsDomainsResult';
import {
    ControlEntityAssetsDomainsResultFromJSON,
    ControlEntityAssetsDomainsResultFromJSONTyped,
    ControlEntityAssetsDomainsResultToJSON,
} from './ControlEntityAssetsDomainsResult';

/**
 * 
 * @export
 * @interface ControlPaginatedEntityAssetsDomainsResponse
 */
export interface ControlPaginatedEntityAssetsDomainsResponse {
    /**
     * 
     * @type {number}
     * @memberof ControlPaginatedEntityAssetsDomainsResponse
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof ControlPaginatedEntityAssetsDomainsResponse
     */
    page_size?: number;
    /**
     * 
     * @type {number}
     * @memberof ControlPaginatedEntityAssetsDomainsResponse
     */
    count?: number;
    /**
     * 
     * @type {Array<ControlEntityAssetsDomainsResult>}
     * @memberof ControlPaginatedEntityAssetsDomainsResponse
     */
    results?: Array<ControlEntityAssetsDomainsResult>;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof ControlPaginatedEntityAssetsDomainsResponse
     */
    available_filters?: { [key: string]: any; };
}

/**
 * Check if a given object implements the ControlPaginatedEntityAssetsDomainsResponse interface.
 */
export function instanceOfControlPaginatedEntityAssetsDomainsResponse(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ControlPaginatedEntityAssetsDomainsResponseFromJSON(json: any): ControlPaginatedEntityAssetsDomainsResponse {
    return ControlPaginatedEntityAssetsDomainsResponseFromJSONTyped(json, false);
}

export function ControlPaginatedEntityAssetsDomainsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlPaginatedEntityAssetsDomainsResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'page': !exists(json, 'page') ? undefined : json['page'],
        'page_size': !exists(json, 'page_size') ? undefined : json['page_size'],
        'count': !exists(json, 'count') ? undefined : json['count'],
        'results': !exists(json, 'results') ? undefined : ((json['results'] as Array<any>).map(ControlEntityAssetsDomainsResultFromJSON)),
        'available_filters': !exists(json, 'available_filters') ? undefined : json['available_filters'],
    };
}

export function ControlPaginatedEntityAssetsDomainsResponseToJSON(value?: ControlPaginatedEntityAssetsDomainsResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'page': value.page,
        'page_size': value.page_size,
        'count': value.count,
        'results': value.results === undefined ? undefined : ((value.results as Array<any>).map(ControlEntityAssetsDomainsResultToJSON)),
        'available_filters': value.available_filters,
    };
}

